
import * as BiIcon from "react-icons/bi"
import * as BsIcon from "react-icons/bs"
import * as TbIcon from "react-icons/tb"
import * as SiIcon from "react-icons/si"


export const SideBarListData = [
    {
        id: 1,
        Name: "Home",
        Icon: <BiIcon.BiHomeAlt className={"h-6 w-6"} />,


    },
    {
        id: 2,
        Name: "Students",
        Icon: <BsIcon.BsFillPersonLinesFill className="h-5 w-5" />,


    },
    // {
    //     id: 3,
    //     Name: "Classes",
    //     Icon: <BsIcon.BsCardList className="h-5 w-5" />,
    // },
    {
        id: 3,
        Name: "School",
        Icon: <BsIcon.BsCardList className="h-5 w-5" />,
    },

    {
        id: 7,
        Name: "Start Class",
        Icon: <SiIcon.SiGoogleclassroom className="h-5 w-5" />,
    },

    // {
    //     id: 5,
    //     Name: "Media",
    //     Icon: <MdIcon.MdOutlinePermMedia className="h-6 w-6" />,
    // },

    {
        id: 4,
        Name: "Logout",
        Icon: <TbIcon.TbLogout className="h-6 w-6" />,
    },
]


export const MapData = [
    {
        "branch_outlet_id": false,
        "id": 14640,
        "latitude_pt": "24.6842596",
        "loc_date": "2023-11-05 21:33:18",
        "loc_type": "checkout",
        "longitude_pt": "46.7928299",
        "name": "EMP/ATT/GEOLOC/0014640"
    },
    {
        "branch_outlet_id": false,
        "id": 14613,
        "latitude_pt": "24.7364736",
        "loc_date": "2023-11-05 20:51:43",
        "loc_type": "tracking",
        "longitude_pt": "46.6948719",
        "name": "EMP/ATT/GEOLOC/0014613"
    },
    {
        "branch_outlet_id": false,
        "id": 14612,
        "latitude_pt": "24.7363926",
        "loc_date": "2023-11-05 20:51:30",
        "loc_type": "tracking",
        "longitude_pt": "46.6948935",
        "name": "EMP/ATT/GEOLOC/0014612"
    },
    {
        "branch_outlet_id": 356,
        "id": 14563,
        "latitude_pt": "24.7364736",
        "loc_date": "2023-11-05 20:51:12",
        "loc_type": "outlet_visit",
        "longitude_pt": "46.6948719",
        "name": "EMP/ATT/GEOLOC/0014563"
    },
    {
        "branch_outlet_id": false,
        "id": 14611,
        "latitude_pt": "24.7843293",
        "loc_date": "2023-11-05 20:34:43",
        "loc_type": "tracking",
        "longitude_pt": "46.6816128",
        "name": "EMP/ATT/GEOLOC/0014611"
    },
    {
        "branch_outlet_id": false,
        "id": 14610,
        "latitude_pt": "24.7843293",
        "loc_date": "2023-11-05 20:34:33",
        "loc_type": "tracking",
        "longitude_pt": "46.6816128",
        "name": "EMP/ATT/GEOLOC/0014610"
    },
    {
        "branch_outlet_id": false,
        "id": 14609,
        "latitude_pt": "24.7843231",
        "loc_date": "2023-11-05 20:27:03",
        "loc_type": "tracking",
        "longitude_pt": "46.6816115",
        "name": "EMP/ATT/GEOLOC/0014609"
    },
    {
        "branch_outlet_id": false,
        "id": 14608,
        "latitude_pt": "24.7846121",
        "loc_date": "2023-11-05 20:25:06",
        "loc_type": "tracking",
        "longitude_pt": "46.6818147",
        "name": "EMP/ATT/GEOLOC/0014608"
    },
    {
        "branch_outlet_id": false,
        "id": 14607,
        "latitude_pt": "24.7843373",
        "loc_date": "2023-11-05 20:24:45",
        "loc_type": "tracking",
        "longitude_pt": "46.6816479",
        "name": "EMP/ATT/GEOLOC/0014607"
    },
    {
        "branch_outlet_id": false,
        "id": 14605,
        "latitude_pt": "24.790408",
        "loc_date": "2023-11-05 20:19:42",
        "loc_type": "tracking",
        "longitude_pt": "46.6795782",
        "name": "EMP/ATT/GEOLOC/0014605"
    },
    {
        "branch_outlet_id": false,
        "id": 14606,
        "latitude_pt": "24.790408",
        "loc_date": "2023-11-05 20:19:33",
        "loc_type": "tracking",
        "longitude_pt": "46.6795782",
        "name": "EMP/ATT/GEOLOC/0014606"
    },
    {
        "branch_outlet_id": false,
        "id": 14604,
        "latitude_pt": "24.7904094",
        "loc_date": "2023-11-05 20:15:40",
        "loc_type": "tracking",
        "longitude_pt": "46.6795919",
        "name": "EMP/ATT/GEOLOC/0014604"
    },
    {
        "branch_outlet_id": false,
        "id": 14603,
        "latitude_pt": "24.7905311",
        "loc_date": "2023-11-05 20:14:53",
        "loc_type": "tracking",
        "longitude_pt": "46.6793548",
        "name": "EMP/ATT/GEOLOC/0014603"
    },
    {
        "branch_outlet_id": false,
        "id": 14602,
        "latitude_pt": "24.7904095",
        "loc_date": "2023-11-05 20:14:39",
        "loc_type": "tracking",
        "longitude_pt": "46.6795908",
        "name": "EMP/ATT/GEOLOC/0014602"
    },
    {
        "branch_outlet_id": false,
        "id": 14601,
        "latitude_pt": "24.7904072",
        "loc_date": "2023-11-05 20:09:42",
        "loc_type": "tracking",
        "longitude_pt": "46.6796011",
        "name": "EMP/ATT/GEOLOC/0014601"
    },
    {
        "branch_outlet_id": false,
        "id": 14600,
        "latitude_pt": "24.7904072",
        "loc_date": "2023-11-05 20:09:33",
        "loc_type": "tracking",
        "longitude_pt": "46.6796011",
        "name": "EMP/ATT/GEOLOC/0014600"
    },
    {
        "branch_outlet_id": false,
        "id": 14599,
        "latitude_pt": "24.7904075",
        "loc_date": "2023-11-05 20:05:40",
        "loc_type": "tracking",
        "longitude_pt": "46.6796066",
        "name": "EMP/ATT/GEOLOC/0014599"
    },
    {
        "branch_outlet_id": false,
        "id": 14598,
        "latitude_pt": "24.7904468",
        "loc_date": "2023-11-05 20:04:52",
        "loc_type": "tracking",
        "longitude_pt": "46.6793858",
        "name": "EMP/ATT/GEOLOC/0014598"
    },
    {
        "branch_outlet_id": false,
        "id": 14597,
        "latitude_pt": "24.7904468",
        "loc_date": "2023-11-05 20:04:39",
        "loc_type": "tracking",
        "longitude_pt": "46.6793858",
        "name": "EMP/ATT/GEOLOC/0014597"
    },
    {
        "branch_outlet_id": false,
        "id": 14596,
        "latitude_pt": "24.7903193",
        "loc_date": "2023-11-05 19:59:42",
        "loc_type": "tracking",
        "longitude_pt": "46.6794665",
        "name": "EMP/ATT/GEOLOC/0014596"
    },
    {
        "branch_outlet_id": false,
        "id": 14595,
        "latitude_pt": "24.7903193",
        "loc_date": "2023-11-05 19:59:33",
        "loc_type": "tracking",
        "longitude_pt": "46.6794665",
        "name": "EMP/ATT/GEOLOC/0014595"
    },
    {
        "branch_outlet_id": false,
        "id": 14594,
        "latitude_pt": "24.7903648",
        "loc_date": "2023-11-05 19:55:40",
        "loc_type": "tracking",
        "longitude_pt": "46.6795957",
        "name": "EMP/ATT/GEOLOC/0014594"
    },
    {
        "branch_outlet_id": false,
        "id": 14593,
        "latitude_pt": "24.790371",
        "loc_date": "2023-11-05 19:54:47",
        "loc_type": "tracking",
        "longitude_pt": "46.6796095",
        "name": "EMP/ATT/GEOLOC/0014593"
    },
    {
        "branch_outlet_id": false,
        "id": 14592,
        "latitude_pt": "24.790371",
        "loc_date": "2023-11-05 19:54:39",
        "loc_type": "tracking",
        "longitude_pt": "46.6796095",
        "name": "EMP/ATT/GEOLOC/0014592"
    },
    {
        "branch_outlet_id": false,
        "id": 14591,
        "latitude_pt": "24.8098202",
        "loc_date": "2023-11-05 19:49:42",
        "loc_type": "tracking",
        "longitude_pt": "46.6700663",
        "name": "EMP/ATT/GEOLOC/0014591"
    },
    {
        "branch_outlet_id": false,
        "id": 14590,
        "latitude_pt": "24.8098202",
        "loc_date": "2023-11-05 19:49:29",
        "loc_type": "tracking",
        "longitude_pt": "46.6700663",
        "name": "EMP/ATT/GEOLOC/0014590"
    },
    {
        "branch_outlet_id": false,
        "id": 14589,
        "latitude_pt": "24.8477784",
        "loc_date": "2023-11-05 19:45:40",
        "loc_type": "tracking",
        "longitude_pt": "46.650869",
        "name": "EMP/ATT/GEOLOC/0014589"
    },
    {
        "branch_outlet_id": false,
        "id": 14588,
        "latitude_pt": "24.8590889",
        "loc_date": "2023-11-05 19:44:47",
        "loc_type": "tracking",
        "longitude_pt": "46.6450369",
        "name": "EMP/ATT/GEOLOC/0014588"
    },
    {
        "branch_outlet_id": false,
        "id": 14587,
        "latitude_pt": "24.8590889",
        "loc_date": "2023-11-05 19:44:37",
        "loc_type": "tracking",
        "longitude_pt": "46.6450369",
        "name": "EMP/ATT/GEOLOC/0014587"
    },
    {
        "branch_outlet_id": false,
        "id": 14586,
        "latitude_pt": "24.8659612",
        "loc_date": "2023-11-05 19:39:25",
        "loc_type": "tracking",
        "longitude_pt": "46.6606616",
        "name": "EMP/ATT/GEOLOC/0014586"
    },
    {
        "branch_outlet_id": false,
        "id": 14585,
        "latitude_pt": "24.8659612",
        "loc_date": "2023-11-05 19:39:12",
        "loc_type": "tracking",
        "longitude_pt": "46.6606616",
        "name": "EMP/ATT/GEOLOC/0014585"
    },
    {
        "branch_outlet_id": false,
        "id": 14584,
        "latitude_pt": "24.8592039",
        "loc_date": "2023-11-05 19:35:23",
        "loc_type": "tracking",
        "longitude_pt": "46.6464675",
        "name": "EMP/ATT/GEOLOC/0014584"
    },
    {
        "branch_outlet_id": false,
        "id": 14583,
        "latitude_pt": "24.8592056",
        "loc_date": "2023-11-05 19:34:30",
        "loc_type": "tracking",
        "longitude_pt": "46.6464635",
        "name": "EMP/ATT/GEOLOC/0014583"
    },
    {
        "branch_outlet_id": false,
        "id": 14582,
        "latitude_pt": "24.8592056",
        "loc_date": "2023-11-05 19:34:18",
        "loc_type": "tracking",
        "longitude_pt": "46.6464635",
        "name": "EMP/ATT/GEOLOC/0014582"
    },
    {
        "branch_outlet_id": false,
        "id": 14581,
        "latitude_pt": "24.85922",
        "loc_date": "2023-11-05 19:29:25",
        "loc_type": "tracking",
        "longitude_pt": "46.646505",
        "name": "EMP/ATT/GEOLOC/0014581"
    },
    {
        "branch_outlet_id": false,
        "id": 14580,
        "latitude_pt": "24.85922",
        "loc_date": "2023-11-05 19:29:12",
        "loc_type": "tracking",
        "longitude_pt": "46.646505",
        "name": "EMP/ATT/GEOLOC/0014580"
    },
    {
        "branch_outlet_id": false,
        "id": 14579,
        "latitude_pt": "24.8592295",
        "loc_date": "2023-11-05 19:23:33",
        "loc_type": "tracking",
        "longitude_pt": "46.6465983",
        "name": "EMP/ATT/GEOLOC/0014579"
    },
    {
        "branch_outlet_id": false,
        "id": 14578,
        "latitude_pt": "24.8592311",
        "loc_date": "2023-11-05 19:22:40",
        "loc_type": "tracking",
        "longitude_pt": "46.6466007",
        "name": "EMP/ATT/GEOLOC/0014578"
    },
    {
        "branch_outlet_id": false,
        "id": 14577,
        "latitude_pt": "24.8592369",
        "loc_date": "2023-11-05 19:22:28",
        "loc_type": "tracking",
        "longitude_pt": "46.6466038",
        "name": "EMP/ATT/GEOLOC/0014577"
    },
    {
        "branch_outlet_id": false,
        "id": 14576,
        "latitude_pt": "24.8592319",
        "loc_date": "2023-11-05 19:17:35",
        "loc_type": "tracking",
        "longitude_pt": "46.6466008",
        "name": "EMP/ATT/GEOLOC/0014576"
    },
    {
        "branch_outlet_id": false,
        "id": 14575,
        "latitude_pt": "24.8592363",
        "loc_date": "2023-11-05 19:17:22",
        "loc_type": "tracking",
        "longitude_pt": "46.6466031",
        "name": "EMP/ATT/GEOLOC/0014575"
    },
    {
        "branch_outlet_id": false,
        "id": 14574,
        "latitude_pt": "24.8592398",
        "loc_date": "2023-11-05 19:13:01",
        "loc_type": "tracking",
        "longitude_pt": "46.6466067",
        "name": "EMP/ATT/GEOLOC/0014574"
    },
    {
        "branch_outlet_id": false,
        "id": 14573,
        "latitude_pt": "24.8592159",
        "loc_date": "2023-11-05 19:11:52",
        "loc_type": "tracking",
        "longitude_pt": "46.646596",
        "name": "EMP/ATT/GEOLOC/0014573"
    },
    {
        "branch_outlet_id": false,
        "id": 14572,
        "latitude_pt": "24.8592159",
        "loc_date": "2023-11-05 19:11:40",
        "loc_type": "tracking",
        "longitude_pt": "46.646596",
        "name": "EMP/ATT/GEOLOC/0014572"
    },
    {
        "branch_outlet_id": false,
        "id": 14571,
        "latitude_pt": "24.859187",
        "loc_date": "2023-11-05 19:04:29",
        "loc_type": "tracking",
        "longitude_pt": "46.6465959",
        "name": "EMP/ATT/GEOLOC/0014571"
    },
    {
        "branch_outlet_id": false,
        "id": 14570,
        "latitude_pt": "24.859187",
        "loc_date": "2023-11-05 19:04:16",
        "loc_type": "tracking",
        "longitude_pt": "46.6465959",
        "name": "EMP/ATT/GEOLOC/0014570"
    },
    {
        "branch_outlet_id": false,
        "id": 14569,
        "latitude_pt": "24.8592097",
        "loc_date": "2023-11-05 19:00:16",
        "loc_type": "tracking",
        "longitude_pt": "46.6464729",
        "name": "EMP/ATT/GEOLOC/0014569"
    },
    {
        "branch_outlet_id": false,
        "id": 14568,
        "latitude_pt": "24.8592091",
        "loc_date": "2023-11-05 18:59:23",
        "loc_type": "tracking",
        "longitude_pt": "46.6464719",
        "name": "EMP/ATT/GEOLOC/0014568"
    },
    {
        "branch_outlet_id": false,
        "id": 14567,
        "latitude_pt": "24.8592091",
        "loc_date": "2023-11-05 18:59:11",
        "loc_type": "tracking",
        "longitude_pt": "46.6464719",
        "name": "EMP/ATT/GEOLOC/0014567"
    },
    {
        "branch_outlet_id": false,
        "id": 14566,
        "latitude_pt": "24.8592204",
        "loc_date": "2023-11-05 18:54:18",
        "loc_type": "tracking",
        "longitude_pt": "46.6464736",
        "name": "EMP/ATT/GEOLOC/0014566"
    },
    {
        "branch_outlet_id": false,
        "id": 14565,
        "latitude_pt": "24.8592204",
        "loc_date": "2023-11-05 18:54:05",
        "loc_type": "tracking",
        "longitude_pt": "46.6464736",
        "name": "EMP/ATT/GEOLOC/0014565"
    },
    {
        "branch_outlet_id": false,
        "id": 14564,
        "latitude_pt": "24.859267",
        "loc_date": "2023-11-05 18:50:16",
        "loc_type": "tracking",
        "longitude_pt": "46.6464453",
        "name": "EMP/ATT/GEOLOC/0014564"
    },
    {
        "branch_outlet_id": false,
        "id": 14529,
        "latitude_pt": "24.8592189",
        "loc_date": "2023-11-05 18:49:11",
        "loc_type": "tracking",
        "longitude_pt": "46.6464385",
        "name": "EMP/ATT/GEOLOC/0014529"
    },
    {
        "branch_outlet_id": 512,
        "id": 14522,
        "latitude_pt": "24.8592189",
        "loc_date": "2023-11-05 18:48:42",
        "loc_type": "outlet_visit",
        "longitude_pt": "46.6464385",
        "name": "EMP/ATT/GEOLOC/0014522"
    },
    {
        "branch_outlet_id": false,
        "id": 14528,
        "latitude_pt": "24.8207553",
        "loc_date": "2023-11-05 18:44:18",
        "loc_type": "tracking",
        "longitude_pt": "46.6647529",
        "name": "EMP/ATT/GEOLOC/0014528"
    },
    {
        "branch_outlet_id": false,
        "id": 14527,
        "latitude_pt": "24.8207553",
        "loc_date": "2023-11-05 18:44:05",
        "loc_type": "tracking",
        "longitude_pt": "46.6647529",
        "name": "EMP/ATT/GEOLOC/0014527"
    },
    {
        "branch_outlet_id": false,
        "id": 14526,
        "latitude_pt": "24.7982459",
        "loc_date": "2023-11-05 18:40:16",
        "loc_type": "tracking",
        "longitude_pt": "46.6877985",
        "name": "EMP/ATT/GEOLOC/0014526"
    },
    {
        "branch_outlet_id": false,
        "id": 14525,
        "latitude_pt": "24.8173614",
        "loc_date": "2023-11-05 18:34:18",
        "loc_type": "tracking",
        "longitude_pt": "46.7324203",
        "name": "EMP/ATT/GEOLOC/0014525"
    },
    {
        "branch_outlet_id": false,
        "id": 14524,
        "latitude_pt": "24.8169792",
        "loc_date": "2023-11-05 18:34:05",
        "loc_type": "tracking",
        "longitude_pt": "46.7326321",
        "name": "EMP/ATT/GEOLOC/0014524"
    },
    {
        "branch_outlet_id": false,
        "id": 14523,
        "latitude_pt": "24.8252481",
        "loc_date": "2023-11-05 18:30:16",
        "loc_type": "tracking",
        "longitude_pt": "46.748946",
        "name": "EMP/ATT/GEOLOC/0014523"
    },
    {
        "branch_outlet_id": false,
        "id": 14515,
        "latitude_pt": "24.825258",
        "loc_date": "2023-11-05 18:22:30",
        "loc_type": "tracking",
        "longitude_pt": "46.7487246",
        "name": "EMP/ATT/GEOLOC/0014515"
    },
    {
        "branch_outlet_id": 501,
        "id": 14510,
        "latitude_pt": "24.825258",
        "loc_date": "2023-11-05 18:21:59",
        "loc_type": "outlet_visit",
        "longitude_pt": "46.7487246",
        "name": "EMP/ATT/GEOLOC/0014510"
    },
    {
        "branch_outlet_id": 218,
        "id": 14423,
        "latitude_pt": "24.7933465",
        "loc_date": "2023-11-05 17:19:52",
        "loc_type": "outlet_visit",
        "longitude_pt": "46.7004601",
        "name": "EMP/ATT/GEOLOC/0014423"
    },
    {
        "branch_outlet_id": false,
        "id": 14436,
        "latitude_pt": "24.7933465",
        "loc_date": "2023-11-05 17:19:37",
        "loc_type": "tracking",
        "longitude_pt": "46.7004601",
        "name": "EMP/ATT/GEOLOC/0014436"
    },
    {
        "branch_outlet_id": false,
        "id": 14435,
        "latitude_pt": "24.7866363",
        "loc_date": "2023-11-05 17:18:55",
        "loc_type": "tracking",
        "longitude_pt": "46.7039402",
        "name": "EMP/ATT/GEOLOC/0014435"
    },
    {
        "branch_outlet_id": false,
        "id": 14434,
        "latitude_pt": "24.7989925",
        "loc_date": "2023-11-05 17:15:14",
        "loc_type": "tracking",
        "longitude_pt": "46.7367556",
        "name": "EMP/ATT/GEOLOC/0014434"
    },
    {
        "branch_outlet_id": false,
        "id": 14433,
        "latitude_pt": "24.7989925",
        "loc_date": "2023-11-05 17:15:00",
        "loc_type": "tracking",
        "longitude_pt": "46.7367556",
        "name": "EMP/ATT/GEOLOC/0014433"
    },
    {
        "branch_outlet_id": false,
        "id": 14432,
        "latitude_pt": "24.8079837",
        "loc_date": "2023-11-05 16:59:34",
        "loc_type": "tracking",
        "longitude_pt": "46.7607575",
        "name": "EMP/ATT/GEOLOC/0014432"
    },
    {
        "branch_outlet_id": false,
        "id": 14431,
        "latitude_pt": "24.8080444",
        "loc_date": "2023-11-05 16:56:48",
        "loc_type": "tracking",
        "longitude_pt": "46.7607203",
        "name": "EMP/ATT/GEOLOC/0014431"
    },
    {
        "branch_outlet_id": false,
        "id": 14430,
        "latitude_pt": "24.8080061",
        "loc_date": "2023-11-05 16:56:29",
        "loc_type": "tracking",
        "longitude_pt": "46.7607689",
        "name": "EMP/ATT/GEOLOC/0014430"
    },
    {
        "branch_outlet_id": false,
        "id": 14429,
        "latitude_pt": "24.8080605",
        "loc_date": "2023-11-05 16:42:32",
        "loc_type": "tracking",
        "longitude_pt": "46.7607092",
        "name": "EMP/ATT/GEOLOC/0014429"
    },
    {
        "branch_outlet_id": false,
        "id": 14428,
        "latitude_pt": "24.8080275",
        "loc_date": "2023-11-05 16:41:38",
        "loc_type": "tracking",
        "longitude_pt": "46.7606538",
        "name": "EMP/ATT/GEOLOC/0014428"
    },
    {
        "branch_outlet_id": false,
        "id": 14427,
        "latitude_pt": "24.8080639",
        "loc_date": "2023-11-05 16:41:19",
        "loc_type": "tracking",
        "longitude_pt": "46.7607164",
        "name": "EMP/ATT/GEOLOC/0014427"
    },
    {
        "branch_outlet_id": false,
        "id": 14426,
        "latitude_pt": "24.7837438",
        "loc_date": "2023-11-05 16:30:50",
        "loc_type": "tracking",
        "longitude_pt": "46.7486577",
        "name": "EMP/ATT/GEOLOC/0014426"
    },
    {
        "branch_outlet_id": false,
        "id": 14425,
        "latitude_pt": "24.782767",
        "loc_date": "2023-11-05 16:29:55",
        "loc_type": "tracking",
        "longitude_pt": "46.7491615",
        "name": "EMP/ATT/GEOLOC/0014425"
    },
    {
        "branch_outlet_id": false,
        "id": 14424,
        "latitude_pt": "24.782957",
        "loc_date": "2023-11-05 16:29:33",
        "loc_type": "tracking",
        "longitude_pt": "46.7494513",
        "name": "EMP/ATT/GEOLOC/0014424"
    },
    {
        "branch_outlet_id": false,
        "id": 14390,
        "latitude_pt": "24.7397678",
        "loc_date": "2023-11-05 16:18:24",
        "loc_type": "tracking",
        "longitude_pt": "46.7801441",
        "name": "EMP/ATT/GEOLOC/0014390"
    },
    {
        "branch_outlet_id": 219,
        "id": 14280,
        "latitude_pt": "24.744342",
        "loc_date": "2023-11-05 16:18:08",
        "loc_type": "outlet_visit",
        "longitude_pt": "46.776857",
        "name": "EMP/ATT/GEOLOC/0014280"
    },
    {
        "branch_outlet_id": false,
        "id": 14389,
        "latitude_pt": "24.7397678",
        "loc_date": "2023-11-05 16:18:05",
        "loc_type": "tracking",
        "longitude_pt": "46.7801441",
        "name": "EMP/ATT/GEOLOC/0014389"
    },
    {
        "branch_outlet_id": false,
        "id": 14388,
        "latitude_pt": "24.684125",
        "loc_date": "2023-11-05 15:32:08",
        "loc_type": "tracking",
        "longitude_pt": "46.7930594",
        "name": "EMP/ATT/GEOLOC/0014388"
    },
    {
        "branch_outlet_id": false,
        "id": 14387,
        "latitude_pt": "24.684125",
        "loc_date": "2023-11-05 15:32:08",
        "loc_type": "tracking",
        "longitude_pt": "46.7930594",
        "name": "EMP/ATT/GEOLOC/0014387"
    },
    {
        "branch_outlet_id": false,
        "id": 14386,
        "latitude_pt": "24.684127",
        "loc_date": "2023-11-05 15:26:57",
        "loc_type": "tracking",
        "longitude_pt": "46.7930639",
        "name": "EMP/ATT/GEOLOC/0014386"
    },
    {
        "branch_outlet_id": false,
        "id": 14385,
        "latitude_pt": "24.6841277",
        "loc_date": "2023-11-05 15:20:22",
        "loc_type": "tracking",
        "longitude_pt": "46.7930659",
        "name": "EMP/ATT/GEOLOC/0014385"
    },
    {
        "branch_outlet_id": false,
        "id": 14384,
        "latitude_pt": "24.6841277",
        "loc_date": "2023-11-05 15:20:22",
        "loc_type": "tracking",
        "longitude_pt": "46.7930659",
        "name": "EMP/ATT/GEOLOC/0014384"
    },
    {
        "branch_outlet_id": false,
        "id": 14383,
        "latitude_pt": "24.6841289",
        "loc_date": "2023-11-05 15:16:43",
        "loc_type": "tracking",
        "longitude_pt": "46.7930678",
        "name": "EMP/ATT/GEOLOC/0014383"
    },
    {
        "branch_outlet_id": false,
        "id": 14382,
        "latitude_pt": "24.6841302",
        "loc_date": "2023-11-05 15:10:04",
        "loc_type": "tracking",
        "longitude_pt": "46.7930686",
        "name": "EMP/ATT/GEOLOC/0014382"
    },
    {
        "branch_outlet_id": false,
        "id": 14381,
        "latitude_pt": "24.6841302",
        "loc_date": "2023-11-05 15:10:04",
        "loc_type": "tracking",
        "longitude_pt": "46.7930686",
        "name": "EMP/ATT/GEOLOC/0014381"
    },
    {
        "branch_outlet_id": false,
        "id": 14380,
        "latitude_pt": "24.6841449",
        "loc_date": "2023-11-05 15:06:43",
        "loc_type": "tracking",
        "longitude_pt": "46.7930907",
        "name": "EMP/ATT/GEOLOC/0014380"
    },
    {
        "branch_outlet_id": false,
        "id": 14379,
        "latitude_pt": "24.6841415",
        "loc_date": "2023-11-05 14:58:39",
        "loc_type": "tracking",
        "longitude_pt": "46.7930859",
        "name": "EMP/ATT/GEOLOC/0014379"
    },
    {
        "branch_outlet_id": false,
        "id": 14378,
        "latitude_pt": "24.6841415",
        "loc_date": "2023-11-05 14:57:48",
        "loc_type": "tracking",
        "longitude_pt": "46.7930859",
        "name": "EMP/ATT/GEOLOC/0014378"
    },
    {
        "branch_outlet_id": false,
        "id": 14377,
        "latitude_pt": "24.6841325",
        "loc_date": "2023-11-05 14:57:16",
        "loc_type": "tracking",
        "longitude_pt": "46.7930731",
        "name": "EMP/ATT/GEOLOC/0014377"
    },
    {
        "branch_outlet_id": false,
        "id": 14376,
        "latitude_pt": "24.6841325",
        "loc_date": "2023-11-05 14:57:16",
        "loc_type": "tracking",
        "longitude_pt": "46.7930731",
        "name": "EMP/ATT/GEOLOC/0014376"
    },
    {
        "branch_outlet_id": false,
        "id": 14375,
        "latitude_pt": "24.6841332",
        "loc_date": "2023-11-05 14:55:25",
        "loc_type": "tracking",
        "longitude_pt": "46.7930743",
        "name": "EMP/ATT/GEOLOC/0014375"
    },
    {
        "branch_outlet_id": false,
        "id": 14374,
        "latitude_pt": "24.6841346",
        "loc_date": "2023-11-05 14:47:48",
        "loc_type": "tracking",
        "longitude_pt": "46.7930766",
        "name": "EMP/ATT/GEOLOC/0014374"
    },
    {
        "branch_outlet_id": false,
        "id": 14373,
        "latitude_pt": "24.6841346",
        "loc_date": "2023-11-05 14:47:09",
        "loc_type": "tracking",
        "longitude_pt": "46.7930766",
        "name": "EMP/ATT/GEOLOC/0014373"
    },
    {
        "branch_outlet_id": false,
        "id": 14372,
        "latitude_pt": "24.6841346",
        "loc_date": "2023-11-05 14:47:09",
        "loc_type": "tracking",
        "longitude_pt": "46.7930766",
        "name": "EMP/ATT/GEOLOC/0014372"
    },
    {
        "branch_outlet_id": false,
        "id": 14371,
        "latitude_pt": "24.6841625",
        "loc_date": "2023-11-05 14:44:56",
        "loc_type": "tracking",
        "longitude_pt": "46.7930768",
        "name": "EMP/ATT/GEOLOC/0014371"
    },
    {
        "branch_outlet_id": false,
        "id": 14370,
        "latitude_pt": "24.684136",
        "loc_date": "2023-11-05 14:37:47",
        "loc_type": "tracking",
        "longitude_pt": "46.7930811",
        "name": "EMP/ATT/GEOLOC/0014370"
    },
    {
        "branch_outlet_id": false,
        "id": 14369,
        "latitude_pt": "24.684136",
        "loc_date": "2023-11-05 14:37:27",
        "loc_type": "tracking",
        "longitude_pt": "46.7930811",
        "name": "EMP/ATT/GEOLOC/0014369"
    },
    {
        "branch_outlet_id": false,
        "id": 14368,
        "latitude_pt": "24.6841345",
        "loc_date": "2023-11-05 14:36:19",
        "loc_type": "tracking",
        "longitude_pt": "46.7930808",
        "name": "EMP/ATT/GEOLOC/0014368"
    },
    {
        "branch_outlet_id": false,
        "id": 14367,
        "latitude_pt": "24.6841345",
        "loc_date": "2023-11-05 14:36:19",
        "loc_type": "tracking",
        "longitude_pt": "46.7930808",
        "name": "EMP/ATT/GEOLOC/0014367"
    },
    {
        "branch_outlet_id": false,
        "id": 14366,
        "latitude_pt": "24.6841466",
        "loc_date": "2023-11-05 14:34:25",
        "loc_type": "tracking",
        "longitude_pt": "46.7930923",
        "name": "EMP/ATT/GEOLOC/0014366"
    },
    {
        "branch_outlet_id": false,
        "id": 14365,
        "latitude_pt": "24.6841348",
        "loc_date": "2023-11-05 14:27:47",
        "loc_type": "tracking",
        "longitude_pt": "46.7930812",
        "name": "EMP/ATT/GEOLOC/0014365"
    },
    {
        "branch_outlet_id": false,
        "id": 14364,
        "latitude_pt": "24.6841344",
        "loc_date": "2023-11-05 14:26:41",
        "loc_type": "tracking",
        "longitude_pt": "46.7930813",
        "name": "EMP/ATT/GEOLOC/0014364"
    },
    {
        "branch_outlet_id": false,
        "id": 14363,
        "latitude_pt": "24.6841344",
        "loc_date": "2023-11-05 14:26:19",
        "loc_type": "tracking",
        "longitude_pt": "46.7930813",
        "name": "EMP/ATT/GEOLOC/0014363"
    },
    {
        "branch_outlet_id": false,
        "id": 14362,
        "latitude_pt": "24.6841344",
        "loc_date": "2023-11-05 14:26:19",
        "loc_type": "tracking",
        "longitude_pt": "46.7930813",
        "name": "EMP/ATT/GEOLOC/0014362"
    },
    {
        "branch_outlet_id": false,
        "id": 14361,
        "latitude_pt": "24.684136",
        "loc_date": "2023-11-05 14:23:39",
        "loc_type": "tracking",
        "longitude_pt": "46.7930823",
        "name": "EMP/ATT/GEOLOC/0014361"
    },
    {
        "branch_outlet_id": false,
        "id": 14360,
        "latitude_pt": "24.6841428",
        "loc_date": "2023-11-05 14:17:41",
        "loc_type": "tracking",
        "longitude_pt": "46.7930871",
        "name": "EMP/ATT/GEOLOC/0014360"
    },
    {
        "branch_outlet_id": false,
        "id": 14359,
        "latitude_pt": "24.6841455",
        "loc_date": "2023-11-05 14:16:38",
        "loc_type": "tracking",
        "longitude_pt": "46.793085",
        "name": "EMP/ATT/GEOLOC/0014359"
    },
    {
        "branch_outlet_id": false,
        "id": 14358,
        "latitude_pt": "24.6841354",
        "loc_date": "2023-11-05 14:16:19",
        "loc_type": "tracking",
        "longitude_pt": "46.7930813",
        "name": "EMP/ATT/GEOLOC/0014358"
    },
    {
        "branch_outlet_id": false,
        "id": 14357,
        "latitude_pt": "24.6841354",
        "loc_date": "2023-11-05 14:16:11",
        "loc_type": "tracking",
        "longitude_pt": "46.7930813",
        "name": "EMP/ATT/GEOLOC/0014357"
    },
    {
        "branch_outlet_id": false,
        "id": 14355,
        "latitude_pt": "24.6841354",
        "loc_date": "2023-11-05 14:16:11",
        "loc_type": "tracking",
        "longitude_pt": "46.7930813",
        "name": "EMP/ATT/GEOLOC/0014355"
    },
    {
        "branch_outlet_id": false,
        "id": 14354,
        "latitude_pt": "24.6841464",
        "loc_date": "2023-11-05 14:13:36",
        "loc_type": "tracking",
        "longitude_pt": "46.7930945",
        "name": "EMP/ATT/GEOLOC/0014354"
    },
    {
        "branch_outlet_id": false,
        "id": 14356,
        "latitude_pt": "24.6841354",
        "loc_date": "2023-11-05 14:07:39",
        "loc_type": "tracking",
        "longitude_pt": "46.7930844",
        "name": "EMP/ATT/GEOLOC/0014356"
    },
    {
        "branch_outlet_id": false,
        "id": 14353,
        "latitude_pt": "24.6841351",
        "loc_date": "2023-11-05 14:06:38",
        "loc_type": "tracking",
        "longitude_pt": "46.7930829",
        "name": "EMP/ATT/GEOLOC/0014353"
    },
    {
        "branch_outlet_id": false,
        "id": 14352,
        "latitude_pt": "24.6841351",
        "loc_date": "2023-11-05 14:06:19",
        "loc_type": "tracking",
        "longitude_pt": "46.7930829",
        "name": "EMP/ATT/GEOLOC/0014352"
    },
    {
        "branch_outlet_id": false,
        "id": 14351,
        "latitude_pt": "24.6841351",
        "loc_date": "2023-11-05 14:06:11",
        "loc_type": "tracking",
        "longitude_pt": "46.7930829",
        "name": "EMP/ATT/GEOLOC/0014351"
    },
    {
        "branch_outlet_id": false,
        "id": 14350,
        "latitude_pt": "24.6841351",
        "loc_date": "2023-11-05 14:03:26",
        "loc_type": "tracking",
        "longitude_pt": "46.7930794",
        "name": "EMP/ATT/GEOLOC/0014350"
    },
    {
        "branch_outlet_id": false,
        "id": 14349,
        "latitude_pt": "24.6841358",
        "loc_date": "2023-11-05 13:57:37",
        "loc_type": "tracking",
        "longitude_pt": "46.7930968",
        "name": "EMP/ATT/GEOLOC/0014349"
    },
    {
        "branch_outlet_id": false,
        "id": 14348,
        "latitude_pt": "24.6841373",
        "loc_date": "2023-11-05 13:56:38",
        "loc_type": "tracking",
        "longitude_pt": "46.7930986",
        "name": "EMP/ATT/GEOLOC/0014348"
    },
    {
        "branch_outlet_id": false,
        "id": 14347,
        "latitude_pt": "24.6841373",
        "loc_date": "2023-11-05 13:56:19",
        "loc_type": "tracking",
        "longitude_pt": "46.7930986",
        "name": "EMP/ATT/GEOLOC/0014347"
    },
    {
        "branch_outlet_id": false,
        "id": 14346,
        "latitude_pt": "24.6841345",
        "loc_date": "2023-11-05 13:56:11",
        "loc_type": "tracking",
        "longitude_pt": "46.7930773",
        "name": "EMP/ATT/GEOLOC/0014346"
    },
    {
        "branch_outlet_id": false,
        "id": 14345,
        "latitude_pt": "24.6841351",
        "loc_date": "2023-11-05 13:53:26",
        "loc_type": "tracking",
        "longitude_pt": "46.7930774",
        "name": "EMP/ATT/GEOLOC/0014345"
    },
    {
        "branch_outlet_id": false,
        "id": 14344,
        "latitude_pt": "24.6841334",
        "loc_date": "2023-11-05 13:47:37",
        "loc_type": "tracking",
        "longitude_pt": "46.7930753",
        "name": "EMP/ATT/GEOLOC/0014344"
    },
    {
        "branch_outlet_id": false,
        "id": 14343,
        "latitude_pt": "24.6841317",
        "loc_date": "2023-11-05 13:46:38",
        "loc_type": "tracking",
        "longitude_pt": "46.7930762",
        "name": "EMP/ATT/GEOLOC/0014343"
    },
    {
        "branch_outlet_id": false,
        "id": 14342,
        "latitude_pt": "24.6841317",
        "loc_date": "2023-11-05 13:46:19",
        "loc_type": "tracking",
        "longitude_pt": "46.7930762",
        "name": "EMP/ATT/GEOLOC/0014342"
    },
    {
        "branch_outlet_id": false,
        "id": 14341,
        "latitude_pt": "24.6841317",
        "loc_date": "2023-11-05 13:46:04",
        "loc_type": "tracking",
        "longitude_pt": "46.7930762",
        "name": "EMP/ATT/GEOLOC/0014341"
    },
    {
        "branch_outlet_id": false,
        "id": 14340,
        "latitude_pt": "24.6841298",
        "loc_date": "2023-11-05 13:43:26",
        "loc_type": "tracking",
        "longitude_pt": "46.7930758",
        "name": "EMP/ATT/GEOLOC/0014340"
    },
    {
        "branch_outlet_id": false,
        "id": 14339,
        "latitude_pt": "24.6841353",
        "loc_date": "2023-11-05 13:37:37",
        "loc_type": "tracking",
        "longitude_pt": "46.7930793",
        "name": "EMP/ATT/GEOLOC/0014339"
    },
    {
        "branch_outlet_id": false,
        "id": 14338,
        "latitude_pt": "24.6841297",
        "loc_date": "2023-11-05 13:36:38",
        "loc_type": "tracking",
        "longitude_pt": "46.7930987",
        "name": "EMP/ATT/GEOLOC/0014338"
    },
    {
        "branch_outlet_id": false,
        "id": 14337,
        "latitude_pt": "24.6841365",
        "loc_date": "2023-11-05 13:36:19",
        "loc_type": "tracking",
        "longitude_pt": "46.7930793",
        "name": "EMP/ATT/GEOLOC/0014337"
    },
    {
        "branch_outlet_id": false,
        "id": 14336,
        "latitude_pt": "24.6841365",
        "loc_date": "2023-11-05 13:36:04",
        "loc_type": "tracking",
        "longitude_pt": "46.7930793",
        "name": "EMP/ATT/GEOLOC/0014336"
    },
    {
        "branch_outlet_id": false,
        "id": 14335,
        "latitude_pt": "24.6841374",
        "loc_date": "2023-11-05 13:33:26",
        "loc_type": "tracking",
        "longitude_pt": "46.7930784",
        "name": "EMP/ATT/GEOLOC/0014335"
    },
    {
        "branch_outlet_id": false,
        "id": 14334,
        "latitude_pt": "24.6841376",
        "loc_date": "2023-11-05 13:27:37",
        "loc_type": "tracking",
        "longitude_pt": "46.7930756",
        "name": "EMP/ATT/GEOLOC/0014334"
    },
    {
        "branch_outlet_id": false,
        "id": 14333,
        "latitude_pt": "24.6841372",
        "loc_date": "2023-11-05 13:26:38",
        "loc_type": "tracking",
        "longitude_pt": "46.7930934",
        "name": "EMP/ATT/GEOLOC/0014333"
    },
    {
        "branch_outlet_id": false,
        "id": 14332,
        "latitude_pt": "24.6841372",
        "loc_date": "2023-11-05 13:26:19",
        "loc_type": "tracking",
        "longitude_pt": "46.7930764",
        "name": "EMP/ATT/GEOLOC/0014332"
    },
    {
        "branch_outlet_id": false,
        "id": 14331,
        "latitude_pt": "24.6841372",
        "loc_date": "2023-11-05 13:26:04",
        "loc_type": "tracking",
        "longitude_pt": "46.7930764",
        "name": "EMP/ATT/GEOLOC/0014331"
    },
    {
        "branch_outlet_id": false,
        "id": 14330,
        "latitude_pt": "24.6841377",
        "loc_date": "2023-11-05 13:23:26",
        "loc_type": "tracking",
        "longitude_pt": "46.7930746",
        "name": "EMP/ATT/GEOLOC/0014330"
    },
    {
        "branch_outlet_id": false,
        "id": 14329,
        "latitude_pt": "24.6841381",
        "loc_date": "2023-11-05 13:17:37",
        "loc_type": "tracking",
        "longitude_pt": "46.7930706",
        "name": "EMP/ATT/GEOLOC/0014329"
    },
    {
        "branch_outlet_id": false,
        "id": 14328,
        "latitude_pt": "24.6841374",
        "loc_date": "2023-11-05 13:16:38",
        "loc_type": "tracking",
        "longitude_pt": "46.7930909",
        "name": "EMP/ATT/GEOLOC/0014328"
    },
    {
        "branch_outlet_id": false,
        "id": 14327,
        "latitude_pt": "24.6841402",
        "loc_date": "2023-11-05 13:16:18",
        "loc_type": "tracking",
        "longitude_pt": "46.79307",
        "name": "EMP/ATT/GEOLOC/0014327"
    },
    {
        "branch_outlet_id": false,
        "id": 14326,
        "latitude_pt": "24.6841402",
        "loc_date": "2023-11-05 13:16:04",
        "loc_type": "tracking",
        "longitude_pt": "46.79307",
        "name": "EMP/ATT/GEOLOC/0014326"
    },
    {
        "branch_outlet_id": false,
        "id": 14325,
        "latitude_pt": "24.6841428",
        "loc_date": "2023-11-05 13:13:26",
        "loc_type": "tracking",
        "longitude_pt": "46.7930739",
        "name": "EMP/ATT/GEOLOC/0014325"
    },
    {
        "branch_outlet_id": false,
        "id": 14324,
        "latitude_pt": "24.6841373",
        "loc_date": "2023-11-05 13:07:39",
        "loc_type": "tracking",
        "longitude_pt": "46.7930558",
        "name": "EMP/ATT/GEOLOC/0014324"
    },
    {
        "branch_outlet_id": false,
        "id": 14323,
        "latitude_pt": "24.6841376",
        "loc_date": "2023-11-05 13:06:38",
        "loc_type": "tracking",
        "longitude_pt": "46.7930579",
        "name": "EMP/ATT/GEOLOC/0014323"
    },
    {
        "branch_outlet_id": false,
        "id": 14322,
        "latitude_pt": "24.6841376",
        "loc_date": "2023-11-05 13:06:16",
        "loc_type": "tracking",
        "longitude_pt": "46.7930579",
        "name": "EMP/ATT/GEOLOC/0014322"
    },
    {
        "branch_outlet_id": false,
        "id": 14321,
        "latitude_pt": "24.6841376",
        "loc_date": "2023-11-05 13:06:04",
        "loc_type": "tracking",
        "longitude_pt": "46.7930579",
        "name": "EMP/ATT/GEOLOC/0014321"
    },
    {
        "branch_outlet_id": false,
        "id": 14320,
        "latitude_pt": "24.6841376",
        "loc_date": "2023-11-05 13:06:04",
        "loc_type": "tracking",
        "longitude_pt": "46.7930579",
        "name": "EMP/ATT/GEOLOC/0014320"
    },
    {
        "branch_outlet_id": false,
        "id": 14319,
        "latitude_pt": "24.6841408",
        "loc_date": "2023-11-05 13:03:26",
        "loc_type": "tracking",
        "longitude_pt": "46.7930475",
        "name": "EMP/ATT/GEOLOC/0014319"
    },
    {
        "branch_outlet_id": false,
        "id": 14318,
        "latitude_pt": "24.6841465",
        "loc_date": "2023-11-05 12:57:37",
        "loc_type": "tracking",
        "longitude_pt": "46.7930494",
        "name": "EMP/ATT/GEOLOC/0014318"
    },
    {
        "branch_outlet_id": false,
        "id": 14317,
        "latitude_pt": "24.6841473",
        "loc_date": "2023-11-05 12:56:38",
        "loc_type": "tracking",
        "longitude_pt": "46.7930419",
        "name": "EMP/ATT/GEOLOC/0014317"
    },
    {
        "branch_outlet_id": false,
        "id": 14316,
        "latitude_pt": "24.6841473",
        "loc_date": "2023-11-05 12:56:16",
        "loc_type": "tracking",
        "longitude_pt": "46.7930419",
        "name": "EMP/ATT/GEOLOC/0014316"
    },
    {
        "branch_outlet_id": false,
        "id": 14315,
        "latitude_pt": "24.6841461",
        "loc_date": "2023-11-05 12:56:04",
        "loc_type": "tracking",
        "longitude_pt": "46.7930897",
        "name": "EMP/ATT/GEOLOC/0014315"
    },
    {
        "branch_outlet_id": false,
        "id": 14314,
        "latitude_pt": "24.6841405",
        "loc_date": "2023-11-05 12:53:26",
        "loc_type": "tracking",
        "longitude_pt": "46.7930333",
        "name": "EMP/ATT/GEOLOC/0014314"
    },
    {
        "branch_outlet_id": false,
        "id": 14313,
        "latitude_pt": "24.6841405",
        "loc_date": "2023-11-05 12:53:12",
        "loc_type": "tracking",
        "longitude_pt": "46.7930333",
        "name": "EMP/ATT/GEOLOC/0014313"
    },
    {
        "branch_outlet_id": false,
        "id": 14312,
        "latitude_pt": "24.6841386",
        "loc_date": "2023-11-05 12:47:37",
        "loc_type": "tracking",
        "longitude_pt": "46.7930945",
        "name": "EMP/ATT/GEOLOC/0014312"
    },
    {
        "branch_outlet_id": false,
        "id": 14311,
        "latitude_pt": "24.6841595",
        "loc_date": "2023-11-05 12:46:34",
        "loc_type": "tracking",
        "longitude_pt": "46.7929695",
        "name": "EMP/ATT/GEOLOC/0014311"
    },
    {
        "branch_outlet_id": false,
        "id": 14310,
        "latitude_pt": "24.6841374",
        "loc_date": "2023-11-05 12:46:08",
        "loc_type": "tracking",
        "longitude_pt": "46.7930968",
        "name": "EMP/ATT/GEOLOC/0014310"
    },
    {
        "branch_outlet_id": false,
        "id": 14309,
        "latitude_pt": "24.6843084",
        "loc_date": "2023-11-05 12:45:59",
        "loc_type": "tracking",
        "longitude_pt": "46.7928358",
        "name": "EMP/ATT/GEOLOC/0014309"
    },
    {
        "branch_outlet_id": false,
        "id": 14308,
        "latitude_pt": "24.6843084",
        "loc_date": "2023-11-05 12:45:59",
        "loc_type": "tracking",
        "longitude_pt": "46.7928358",
        "name": "EMP/ATT/GEOLOC/0014308"
    },
    {
        "branch_outlet_id": false,
        "id": 14307,
        "latitude_pt": "24.683275",
        "loc_date": "2023-11-05 12:43:10",
        "loc_type": "tracking",
        "longitude_pt": "46.7893026",
        "name": "EMP/ATT/GEOLOC/0014307"
    },
    {
        "branch_outlet_id": false,
        "id": 14306,
        "latitude_pt": "24.683275",
        "loc_date": "2023-11-05 12:42:57",
        "loc_type": "tracking",
        "longitude_pt": "46.7893026",
        "name": "EMP/ATT/GEOLOC/0014306"
    },
    {
        "branch_outlet_id": false,
        "id": 14305,
        "latitude_pt": "24.6785354",
        "loc_date": "2023-11-05 12:37:21",
        "loc_type": "tracking",
        "longitude_pt": "46.7737909",
        "name": "EMP/ATT/GEOLOC/0014305"
    },
    {
        "branch_outlet_id": false,
        "id": 14304,
        "latitude_pt": "24.6834164",
        "loc_date": "2023-11-05 12:36:22",
        "loc_type": "tracking",
        "longitude_pt": "46.7765021",
        "name": "EMP/ATT/GEOLOC/0014304"
    },
    {
        "branch_outlet_id": false,
        "id": 14303,
        "latitude_pt": "24.6834164",
        "loc_date": "2023-11-05 12:35:57",
        "loc_type": "tracking",
        "longitude_pt": "46.7765021",
        "name": "EMP/ATT/GEOLOC/0014303"
    },
    {
        "branch_outlet_id": false,
        "id": 14302,
        "latitude_pt": "24.6914099",
        "loc_date": "2023-11-05 12:35:46",
        "loc_type": "tracking",
        "longitude_pt": "46.7746725",
        "name": "EMP/ATT/GEOLOC/0014302"
    },
    {
        "branch_outlet_id": false,
        "id": 14301,
        "latitude_pt": "24.6999328",
        "loc_date": "2023-11-05 12:33:10",
        "loc_type": "tracking",
        "longitude_pt": "46.771244",
        "name": "EMP/ATT/GEOLOC/0014301"
    },
    {
        "branch_outlet_id": false,
        "id": 14300,
        "latitude_pt": "24.6999328",
        "loc_date": "2023-11-05 12:32:57",
        "loc_type": "tracking",
        "longitude_pt": "46.771244",
        "name": "EMP/ATT/GEOLOC/0014300"
    },
    {
        "branch_outlet_id": false,
        "id": 14299,
        "latitude_pt": "24.7005141",
        "loc_date": "2023-11-05 12:27:05",
        "loc_type": "tracking",
        "longitude_pt": "46.7397225",
        "name": "EMP/ATT/GEOLOC/0014299"
    },
    {
        "branch_outlet_id": false,
        "id": 14298,
        "latitude_pt": "24.6943986",
        "loc_date": "2023-11-05 12:26:22",
        "loc_type": "tracking",
        "longitude_pt": "46.7283565",
        "name": "EMP/ATT/GEOLOC/0014298"
    },
    {
        "branch_outlet_id": false,
        "id": 14297,
        "latitude_pt": "24.6943986",
        "loc_date": "2023-11-05 12:25:57",
        "loc_type": "tracking",
        "longitude_pt": "46.7283565",
        "name": "EMP/ATT/GEOLOC/0014297"
    },
    {
        "branch_outlet_id": false,
        "id": 14296,
        "latitude_pt": "24.6937806",
        "loc_date": "2023-11-05 12:25:46",
        "loc_type": "tracking",
        "longitude_pt": "46.7243236",
        "name": "EMP/ATT/GEOLOC/0014296"
    },
    {
        "branch_outlet_id": false,
        "id": 14295,
        "latitude_pt": "24.6937806",
        "loc_date": "2023-11-05 12:25:46",
        "loc_type": "tracking",
        "longitude_pt": "46.7243236",
        "name": "EMP/ATT/GEOLOC/0014295"
    },
    {
        "branch_outlet_id": false,
        "id": 14294,
        "latitude_pt": "24.6924795",
        "loc_date": "2023-11-05 12:23:10",
        "loc_type": "tracking",
        "longitude_pt": "46.7182985",
        "name": "EMP/ATT/GEOLOC/0014294"
    },
    {
        "branch_outlet_id": false,
        "id": 14293,
        "latitude_pt": "24.6926549",
        "loc_date": "2023-11-05 12:22:57",
        "loc_type": "tracking",
        "longitude_pt": "46.7172562",
        "name": "EMP/ATT/GEOLOC/0014293"
    },
    {
        "branch_outlet_id": false,
        "id": 14292,
        "latitude_pt": "24.6859759",
        "loc_date": "2023-11-05 12:17:05",
        "loc_type": "tracking",
        "longitude_pt": "46.7058571",
        "name": "EMP/ATT/GEOLOC/0014292"
    },
    {
        "branch_outlet_id": false,
        "id": 14291,
        "latitude_pt": "24.6853439",
        "loc_date": "2023-11-05 12:16:22",
        "loc_type": "tracking",
        "longitude_pt": "46.7042634",
        "name": "EMP/ATT/GEOLOC/0014291"
    },
    {
        "branch_outlet_id": false,
        "id": 14290,
        "latitude_pt": "24.6853439",
        "loc_date": "2023-11-05 12:15:57",
        "loc_type": "tracking",
        "longitude_pt": "46.7042634",
        "name": "EMP/ATT/GEOLOC/0014290"
    },
    {
        "branch_outlet_id": false,
        "id": 14289,
        "latitude_pt": "24.684939",
        "loc_date": "2023-11-05 12:15:46",
        "loc_type": "tracking",
        "longitude_pt": "46.7045026",
        "name": "EMP/ATT/GEOLOC/0014289"
    },
    {
        "branch_outlet_id": false,
        "id": 14288,
        "latitude_pt": "24.6842696",
        "loc_date": "2023-11-05 12:13:10",
        "loc_type": "tracking",
        "longitude_pt": "46.7018834",
        "name": "EMP/ATT/GEOLOC/0014288"
    },
    {
        "branch_outlet_id": false,
        "id": 14287,
        "latitude_pt": "24.6842696",
        "loc_date": "2023-11-05 12:12:57",
        "loc_type": "tracking",
        "longitude_pt": "46.7018834",
        "name": "EMP/ATT/GEOLOC/0014287"
    },
    {
        "branch_outlet_id": false,
        "id": 14286,
        "latitude_pt": "24.6816018",
        "loc_date": "2023-11-05 12:07:05",
        "loc_type": "tracking",
        "longitude_pt": "46.6956244",
        "name": "EMP/ATT/GEOLOC/0014286"
    },
    {
        "branch_outlet_id": false,
        "id": 14285,
        "latitude_pt": "24.6803082",
        "loc_date": "2023-11-05 12:06:21",
        "loc_type": "tracking",
        "longitude_pt": "46.6933201",
        "name": "EMP/ATT/GEOLOC/0014285"
    },
    {
        "branch_outlet_id": false,
        "id": 14284,
        "latitude_pt": "24.6804652",
        "loc_date": "2023-11-05 12:05:57",
        "loc_type": "tracking",
        "longitude_pt": "46.6921625",
        "name": "EMP/ATT/GEOLOC/0014284"
    },
    {
        "branch_outlet_id": false,
        "id": 14283,
        "latitude_pt": "24.6830818",
        "loc_date": "2023-11-05 12:05:46",
        "loc_type": "tracking",
        "longitude_pt": "46.697584",
        "name": "EMP/ATT/GEOLOC/0014283"
    },
    {
        "branch_outlet_id": false,
        "id": 14282,
        "latitude_pt": "24.6830839",
        "loc_date": "2023-11-05 12:02:17",
        "loc_type": "tracking",
        "longitude_pt": "46.6975772",
        "name": "EMP/ATT/GEOLOC/0014282"
    },
    {
        "branch_outlet_id": false,
        "id": 14281,
        "latitude_pt": "24.6830792",
        "loc_date": "2023-11-05 12:02:02",
        "loc_type": "tracking",
        "longitude_pt": "46.6975791",
        "name": "EMP/ATT/GEOLOC/0014281"
    },
    {
        "branch_outlet_id": false,
        "id": 14072,
        "latitude_pt": "24.683076",
        "loc_date": "2023-11-05 11:54:37",
        "loc_type": "tracking",
        "longitude_pt": "46.6975557",
        "name": "EMP/ATT/GEOLOC/0014072"
    },
    {
        "branch_outlet_id": false,
        "id": 14071,
        "latitude_pt": "24.6830774",
        "loc_date": "2023-11-05 11:54:12",
        "loc_type": "tracking",
        "longitude_pt": "46.6975531",
        "name": "EMP/ATT/GEOLOC/0014071"
    },
    {
        "branch_outlet_id": false,
        "id": 14070,
        "latitude_pt": "24.6830592",
        "loc_date": "2023-11-05 11:53:46",
        "loc_type": "tracking",
        "longitude_pt": "46.6976012",
        "name": "EMP/ATT/GEOLOC/0014070"
    },
    {
        "branch_outlet_id": false,
        "id": 14069,
        "latitude_pt": "24.6830817",
        "loc_date": "2023-11-05 11:49:38",
        "loc_type": "tracking",
        "longitude_pt": "46.6975936",
        "name": "EMP/ATT/GEOLOC/0014069"
    },
    {
        "branch_outlet_id": false,
        "id": 14068,
        "latitude_pt": "24.6830817",
        "loc_date": "2023-11-05 11:49:25",
        "loc_type": "tracking",
        "longitude_pt": "46.6975936",
        "name": "EMP/ATT/GEOLOC/0014068"
    },
    {
        "branch_outlet_id": 217,
        "id": 14039,
        "latitude_pt": "24.6830817",
        "loc_date": "2023-11-05 11:49:04",
        "loc_type": "outlet_visit",
        "longitude_pt": "46.6975936",
        "name": "EMP/ATT/GEOLOC/0014039"
    },
    {
        "branch_outlet_id": false,
        "id": 14067,
        "latitude_pt": "24.6981829",
        "loc_date": "2023-11-05 11:42:03",
        "loc_type": "tracking",
        "longitude_pt": "46.7035133",
        "name": "EMP/ATT/GEOLOC/0014067"
    },
    {
        "branch_outlet_id": false,
        "id": 14066,
        "latitude_pt": "24.6993032",
        "loc_date": "2023-11-05 11:41:39",
        "loc_type": "tracking",
        "longitude_pt": "46.7039749",
        "name": "EMP/ATT/GEOLOC/0014066"
    },
    {
        "branch_outlet_id": false,
        "id": 14065,
        "latitude_pt": "24.6993032",
        "loc_date": "2023-11-05 11:41:27",
        "loc_type": "tracking",
        "longitude_pt": "46.7039749",
        "name": "EMP/ATT/GEOLOC/0014065"
    },
    {
        "branch_outlet_id": false,
        "id": 14064,
        "latitude_pt": "24.6993032",
        "loc_date": "2023-11-05 11:41:23",
        "loc_type": "tracking",
        "longitude_pt": "46.7039749",
        "name": "EMP/ATT/GEOLOC/0014064"
    },
    {
        "branch_outlet_id": false,
        "id": 14063,
        "latitude_pt": "24.7121086",
        "loc_date": "2023-11-05 11:38:38",
        "loc_type": "tracking",
        "longitude_pt": "46.7015599",
        "name": "EMP/ATT/GEOLOC/0014063"
    },
    {
        "branch_outlet_id": false,
        "id": 14062,
        "latitude_pt": "24.7330079",
        "loc_date": "2023-11-05 11:32:03",
        "loc_type": "tracking",
        "longitude_pt": "46.7082532",
        "name": "EMP/ATT/GEOLOC/0014062"
    },
    {
        "branch_outlet_id": false,
        "id": 14061,
        "latitude_pt": "24.7313692",
        "loc_date": "2023-11-05 11:31:39",
        "loc_type": "tracking",
        "longitude_pt": "46.7046773",
        "name": "EMP/ATT/GEOLOC/0014061"
    },
    {
        "branch_outlet_id": false,
        "id": 14060,
        "latitude_pt": "24.7313692",
        "loc_date": "2023-11-05 11:31:27",
        "loc_type": "tracking",
        "longitude_pt": "46.7046773",
        "name": "EMP/ATT/GEOLOC/0014060"
    },
    {
        "branch_outlet_id": false,
        "id": 14059,
        "latitude_pt": "24.7313692",
        "loc_date": "2023-11-05 11:31:22",
        "loc_type": "tracking",
        "longitude_pt": "46.7046773",
        "name": "EMP/ATT/GEOLOC/0014059"
    },
    {
        "branch_outlet_id": false,
        "id": 14058,
        "latitude_pt": "24.7360382",
        "loc_date": "2023-11-05 11:28:38",
        "loc_type": "tracking",
        "longitude_pt": "46.6951571",
        "name": "EMP/ATT/GEOLOC/0014058"
    },
    {
        "branch_outlet_id": false,
        "id": 14057,
        "latitude_pt": "24.7364952",
        "loc_date": "2023-11-05 11:20:05",
        "loc_type": "tracking",
        "longitude_pt": "46.6948879",
        "name": "EMP/ATT/GEOLOC/0014057"
    },
    {
        "branch_outlet_id": false,
        "id": 14056,
        "latitude_pt": "24.7364985",
        "loc_date": "2023-11-05 11:19:41",
        "loc_type": "tracking",
        "longitude_pt": "46.6948804",
        "name": "EMP/ATT/GEOLOC/0014056"
    },
    {
        "branch_outlet_id": false,
        "id": 14055,
        "latitude_pt": "24.7364985",
        "loc_date": "2023-11-05 11:19:29",
        "loc_type": "tracking",
        "longitude_pt": "46.6948804",
        "name": "EMP/ATT/GEOLOC/0014055"
    },
    {
        "branch_outlet_id": false,
        "id": 14054,
        "latitude_pt": "24.7364985",
        "loc_date": "2023-11-05 11:19:24",
        "loc_type": "tracking",
        "longitude_pt": "46.6948804",
        "name": "EMP/ATT/GEOLOC/0014054"
    },
    {
        "branch_outlet_id": false,
        "id": 14053,
        "latitude_pt": "24.7364932",
        "loc_date": "2023-11-05 11:14:35",
        "loc_type": "tracking",
        "longitude_pt": "46.6948841",
        "name": "EMP/ATT/GEOLOC/0014053"
    },
    {
        "branch_outlet_id": false,
        "id": 14052,
        "latitude_pt": "24.7364904",
        "loc_date": "2023-11-05 11:06:38",
        "loc_type": "tracking",
        "longitude_pt": "46.6948862",
        "name": "EMP/ATT/GEOLOC/0014052"
    },
    {
        "branch_outlet_id": false,
        "id": 14051,
        "latitude_pt": "24.7364779",
        "loc_date": "2023-11-05 11:05:35",
        "loc_type": "tracking",
        "longitude_pt": "46.6948713",
        "name": "EMP/ATT/GEOLOC/0014051"
    },
    {
        "branch_outlet_id": false,
        "id": 14050,
        "latitude_pt": "24.7364779",
        "loc_date": "2023-11-05 11:05:15",
        "loc_type": "tracking",
        "longitude_pt": "46.6948713",
        "name": "EMP/ATT/GEOLOC/0014050"
    },
    {
        "branch_outlet_id": false,
        "id": 14049,
        "latitude_pt": "24.7364779",
        "loc_date": "2023-11-05 11:05:10",
        "loc_type": "tracking",
        "longitude_pt": "46.6948713",
        "name": "EMP/ATT/GEOLOC/0014049"
    },
    {
        "branch_outlet_id": false,
        "id": 14048,
        "latitude_pt": "24.7364793",
        "loc_date": "2023-11-05 11:01:14",
        "loc_type": "tracking",
        "longitude_pt": "46.6948838",
        "name": "EMP/ATT/GEOLOC/0014048"
    },
    {
        "branch_outlet_id": false,
        "id": 14047,
        "latitude_pt": "24.7364937",
        "loc_date": "2023-11-05 10:50:10",
        "loc_type": "tracking",
        "longitude_pt": "46.6948875",
        "name": "EMP/ATT/GEOLOC/0014047"
    },
    {
        "branch_outlet_id": false,
        "id": 14046,
        "latitude_pt": "24.7364802",
        "loc_date": "2023-11-05 10:48:42",
        "loc_type": "tracking",
        "longitude_pt": "46.6948895",
        "name": "EMP/ATT/GEOLOC/0014046"
    },
    {
        "branch_outlet_id": false,
        "id": 14045,
        "latitude_pt": "24.7364743",
        "loc_date": "2023-11-05 10:48:32",
        "loc_type": "tracking",
        "longitude_pt": "46.6948786",
        "name": "EMP/ATT/GEOLOC/0014045"
    },
    {
        "branch_outlet_id": false,
        "id": 14044,
        "latitude_pt": "24.7364743",
        "loc_date": "2023-11-05 10:48:24",
        "loc_type": "tracking",
        "longitude_pt": "46.6948786",
        "name": "EMP/ATT/GEOLOC/0014044"
    },
    {
        "branch_outlet_id": false,
        "id": 14009,
        "latitude_pt": "24.7364762",
        "loc_date": "2023-11-05 10:34:47",
        "loc_type": "tracking",
        "longitude_pt": "46.6948778",
        "name": "EMP/ATT/GEOLOC/0014009"
    },
    {
        "branch_outlet_id": false,
        "id": 14008,
        "latitude_pt": "24.7364779",
        "loc_date": "2023-11-05 10:34:25",
        "loc_type": "tracking",
        "longitude_pt": "46.694877",
        "name": "EMP/ATT/GEOLOC/0014008"
    },
    {
        "branch_outlet_id": false,
        "id": 14007,
        "latitude_pt": "24.7364779",
        "loc_date": "2023-11-05 10:34:15",
        "loc_type": "tracking",
        "longitude_pt": "46.694877",
        "name": "EMP/ATT/GEOLOC/0014007"
    },
    {
        "branch_outlet_id": 356,
        "id": 14001,
        "latitude_pt": "24.7364762",
        "loc_date": "2023-11-05 10:34:14",
        "loc_type": "outlet_visit",
        "longitude_pt": "46.6948778",
        "name": "EMP/ATT/GEOLOC/0014001"
    },
    {
        "branch_outlet_id": false,
        "id": 14006,
        "latitude_pt": "24.7364984",
        "loc_date": "2023-11-05 10:34:03",
        "loc_type": "tracking",
        "longitude_pt": "46.6948893",
        "name": "EMP/ATT/GEOLOC/0014006"
    },
    {
        "branch_outlet_id": false,
        "id": 14005,
        "latitude_pt": "24.7528111",
        "loc_date": "2023-11-05 10:24:22",
        "loc_type": "tracking",
        "longitude_pt": "46.7204865",
        "name": "EMP/ATT/GEOLOC/0014005"
    },
    {
        "branch_outlet_id": false,
        "id": 14004,
        "latitude_pt": "24.7528111",
        "loc_date": "2023-11-05 10:24:12",
        "loc_type": "tracking",
        "longitude_pt": "46.7204865",
        "name": "EMP/ATT/GEOLOC/0014004"
    },
    {
        "branch_outlet_id": false,
        "id": 14002,
        "latitude_pt": "24.7528111",
        "loc_date": "2023-11-05 10:24:01",
        "loc_type": "tracking",
        "longitude_pt": "46.7204865",
        "name": "EMP/ATT/GEOLOC/0014002"
    },
    {
        "branch_outlet_id": false,
        "id": 14003,
        "latitude_pt": "24.7989092",
        "loc_date": "2023-11-05 10:14:22",
        "loc_type": "tracking",
        "longitude_pt": "46.6972185",
        "name": "EMP/ATT/GEOLOC/0014003"
    },
    {
        "branch_outlet_id": 218,
        "id": 14000,
        "latitude_pt": "24.7989092",
        "loc_date": "2023-11-05 10:13:38",
        "loc_type": "outlet_visit",
        "longitude_pt": "46.6972185",
        "name": "EMP/ATT/GEOLOC/0014000"
    },
    {
        "branch_outlet_id": false,
        "id": 13961,
        "latitude_pt": "24.7453338",
        "loc_date": "2023-11-05 07:13:46",
        "loc_type": "tracking",
        "longitude_pt": "46.7763404",
        "name": "EMP/ATT/GEOLOC/0013961"
    },
    {
        "branch_outlet_id": 219,
        "id": 13956,
        "latitude_pt": "24.7453338",
        "loc_date": "2023-11-05 07:13:12",
        "loc_type": "outlet_visit",
        "longitude_pt": "46.7763404",
        "name": "EMP/ATT/GEOLOC/0013956"
    },
    {
        "branch_outlet_id": false,
        "id": 13960,
        "latitude_pt": "24.7453276",
        "loc_date": "2023-11-05 07:08:33",
        "loc_type": "tracking",
        "longitude_pt": "46.7763381",
        "name": "EMP/ATT/GEOLOC/0013960"
    },
    {
        "branch_outlet_id": false,
        "id": 13959,
        "latitude_pt": "24.7292949",
        "loc_date": "2023-11-05 06:58:33",
        "loc_type": "tracking",
        "longitude_pt": "46.786116",
        "name": "EMP/ATT/GEOLOC/0013959"
    },
    {
        "branch_outlet_id": false,
        "id": 13958,
        "latitude_pt": "24.6902353",
        "loc_date": "2023-11-05 06:48:33",
        "loc_type": "tracking",
        "longitude_pt": "46.7755125",
        "name": "EMP/ATT/GEOLOC/0013958"
    },
    {
        "branch_outlet_id": false,
        "id": 13957,
        "latitude_pt": "24.6841544",
        "loc_date": "2023-11-05 06:38:32",
        "loc_type": "tracking",
        "longitude_pt": "46.7926649",
        "name": "EMP/ATT/GEOLOC/0013957"
    },
    {
        "branch_outlet_id": false,
        "id": 13937,
        "latitude_pt": "24.6841544",
        "loc_date": "2023-11-05 06:37:55",
        "loc_type": "checkin",
        "longitude_pt": "46.7926649",
        "name": "EMP/ATT/GEOLOC/0013937"
    }
]